// main.js
import { createApp, watch } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'
import FontAwesomeIcon from './plugins/font-awesome'
import './assets/main.css'
import '../node_modules/flowbite-vue/dist/index.css'
import { useDataStore } from './stores/useDataStore.js'
import { useInstallPromptStore } from './stores/useInstallPromptStore.js'

// استيراد ملفات الترجمة
import enMsg from '../src/plugins/locales/en.json'
import arMsg from '../src/plugins/locales/ar.json'

// إعداد i18n
const i18n = createI18n({
  legacy: false,
  locale: JSON.parse(localStorage.getItem('myAppData') || '{"language": "en"}').language.toLowerCase(),
  messages: {
    en: enMsg,
    ar: arMsg
  }
})

const app = createApp(App)

// إنشاء مثيل Pinia
const pinia = createPinia()

// تسجيل FontAwesomeIcon بشكل عام
app.component('font-awesome-icon', FontAwesomeIcon)

// استخدام i18n في التطبيق
app.use(i18n)
app.use(router)
app.use(pinia)

// تثبيت تطبيق Vue في الـ DOM
app.mount('#app')

// الوصول إلى المتجر
const dataStore = useDataStore()

// تعريف دالة updateDirection
const updateDirection = () => {
  const dir = dataStore.language.toLowerCase() === 'ar' ? 'rtl' : 'ltr'
  document.documentElement.setAttribute('dir', dir)
}

// استدعاء updateDirection في البداية لضبط الاتجاه عند تحميل التطبيق
updateDirection()

// مراقبة خاصية 'language'
watch(
  () => dataStore.language,
  (newLanguage) => {
    const newLocale = newLanguage.toLowerCase()
    i18n.global.locale.value = newLocale
    updateDirection()
  },
  { immediate: true }
)

// استخدام متجر التثبيت
const installPromptStore = useInstallPromptStore()

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault()
  installPromptStore.setDeferredPrompt(e)
})
